import {
  type FeatureCheckInput,
  type FeatureCheckSuccess,
  HOUR,
  isNotEmpty,
  Logger,
  type Milestone,
  type StrictFeatureId,
  WEEK,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { featureKey } from '../keys'

export type FeatureState = {
  isLoading: boolean
  isEnabled: boolean
  milestone?: Milestone
}

export type FeatureCheckHookInput = {
  featureId: StrictFeatureId
  placeholder?: boolean
}

const logger = new Logger('useFeature')

export function useFeature(input: FeatureCheckHookInput): FeatureState {
  const response = useTantalimQuery<FeatureCheckInput, FeatureCheckSuccess, FeatureCheckSuccess>({
    url: '/feature/check',
    queryKey: featureKey(input.featureId),
    input,
    convertResponse: (data) => data,
    options: {
      enabled: isNotEmpty(input.featureId),
      gcTime: WEEK,
      staleTime: HOUR,
    },
  })

  if (response.data !== undefined) {
    return {
      isLoading: response.isLoading,
      isEnabled: response.data.enabled,
      milestone: response.data.milestone,
    }
  }

  if (!response.isLoading) {
    logger.warn(`${input.featureId} is missing. Make sure it's defined. ${response.error}`)
  }

  return {
    isLoading: response.isLoading,
    isEnabled: input.placeholder ?? false,
  }
}
